import { useState } from "react";
import { api } from "../api";

const initialForm = {
  fullName: "",
  phone: "",
  eventType: "",
  location: "",
  eventDate: "",
};

export default function Quotes() {
  const [form, setForm] = useState(initialForm);
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setMessage("");
    setSuccess(false);

    try {
      await api.post("/quotes", form);
      setMessage("Cotización enviada correctamente. Nos pondremos en contacto contigo.");
      setSuccess(true);
      setForm(initialForm);
    } catch (err) {
      setMessage(err?.response?.data?.message || "No fue posible enviar la cotización.");
    }
  }

  return (
    <section className="space-y-8">
      <div className="rounded-2xl border border-orange-400/20 bg-black/20 p-6">
        <h1 className="text-2xl font-bold uppercase tracking-wide">Solicitar Cotización</h1>
        <p className="mt-2 text-sm text-orange-100/70">
          Completa el formulario y te enviaremos una cotización personalizada.
        </p>

        {message && (
          <p className={`mt-4 rounded-xl border p-3 text-sm ${success ? "border-green-500/40 text-green-300" : "border-orange-500/40 text-orange-200"}`}>
            {message}
          </p>
        )}

        <form className="mt-6 grid gap-4 md:grid-cols-2" onSubmit={submit}>
          <input
            className="rounded-lg border border-orange-400/20 bg-black/30 p-3 placeholder-orange-200/40 focus:border-orange-400 focus:outline-none"
            placeholder="Nombre completo"
            value={form.fullName}
            onChange={(e) => setForm({ ...form, fullName: e.target.value })}
            required
          />
          <input
            className="rounded-lg border border-orange-400/20 bg-black/30 p-3 placeholder-orange-200/40 focus:border-orange-400 focus:outline-none"
            placeholder="Teléfono"
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
            required
          />
          <select
            className="rounded-lg border border-orange-400/20 bg-black/30 p-3 focus:border-orange-400 focus:outline-none"
            value={form.eventType}
            onChange={(e) => setForm({ ...form, eventType: e.target.value })}
            required
          >
            <option value="" disabled>Tipo de evento</option>
            <option value="Boda">Boda</option>
            <option value="XV Años">XV Años</option>
            <option value="Cumpleaños">Cumpleaños</option>
            <option value="Fiesta Corporativa">Fiesta Corporativa</option>
            <option value="Mayordomía">Mayordomía</option>
            <option value="Graduación">Graduación</option>
            <option value="Otro">Otro</option>
          </select>
          <input
            className="rounded-lg border border-orange-400/20 bg-black/30 p-3 placeholder-orange-200/40 focus:border-orange-400 focus:outline-none"
            type="date"
            value={form.eventDate}
            onChange={(e) => setForm({ ...form, eventDate: e.target.value })}
            required
          />
          <input
            className="rounded-lg border border-orange-400/20 bg-black/30 p-3 placeholder-orange-200/40 focus:border-orange-400 focus:outline-none md:col-span-2"
            placeholder="Lugar del evento y número de personas aproximadas"      value={form.location}
            onChange={(e) => setForm({ ...form, location: e.target.value })}
            required
          />
          <button
            className="rounded-lg bg-gradient-to-r from-orange-500 to-amber-400 px-6 py-3 font-bold text-black transition-transform hover:scale-[1.02] md:col-span-2"
            type="submit"
          >
            Enviar Solicitud
          </button>
        </form>
      </div>
    </section>
  );
}
